export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-r from-primary-500 via-primary-600 to-accent-500 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-background-50/20">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-background-50 mb-2">
              随时随地 · 手机看片更便捷
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed">
              悟空影视全面适配移动端，无论 iOS 还是 Android，打开浏览器即可流畅观影。支持收藏同步、播放记忆，多设备无缝切换，让追剧不再受设备限制。无需下载 APP，节省手机空间，即开即看。
            </p>
          </div>
          <div className="flex-shrink-0">
            <span className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-semibold text-sm rounded-lg cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors">
              <i className="ri-qr-scan-line"></i>
              扫码体验
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}